import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: 'Розмір сторінки',
	PageOrientation: 'Орієнтація сторінки',
	Format: 'Формат',
	DPI: 'DPI',
	Generate: 'Згенерувати',
	LanguageName: 'українська',
	LanguageCode: 'uk'
};

export default translation;
